import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const categories = [
  { id: 'actualites', name: 'Actualités' },
  { id: 'histoire', name: 'Histoire' },
  { id: 'culture', name: 'Culture' },
  { id: 'politique', name: 'Politique' },
  { id: 'sport', name: 'Sport' },
  { id: 'justice', name: 'Justice' },
  { id: 'guide', name: 'Guides', isSpecial: true },
  { id: 'faq', name: 'FAQ', isSpecial: true },
  { id: 'archives', name: 'Archives', isSpecial: true },
];

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  
  const currentDate = new Date().toLocaleDateString('fr-FR', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <header className="bg-white border-b border-stone-200 sticky top-0 z-50 bg-white/95 backdrop-blur-sm">
      {/* Top bar with date */}
      <div className="border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
          <p className="text-xs text-stone-500 font-inter text-center capitalize">
            {currentDate}
          </p>
        </div>
      </div>
      
      {/* Logo */}
      <div className="border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Link to="/" className="block text-center" data-testid="header-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_versailles-actu/artifacts/x061u1gg_logo%20Versailles%2B.jpeg" 
              alt="Versailles Plus" 
              className="h-20 sm:h-24 lg:h-28 mx-auto object-contain"
            />
          </Link>
        </div>
      </div>
      
      {/* Navigation */}
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Desktop navigation */}
        <div className="hidden md:flex items-center justify-center space-x-8 py-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={cat.isSpecial ? `/${cat.id}` : `/categorie/${cat.id}`}
              data-testid={`nav-${cat.id}`}
              className={`font-inter text-sm font-medium tracking-wide uppercase transition-colors duration-200 ${
                cat.isPdf ? 'text-red-600 hover:text-red-800' :
                cat.isSpecial ? 'text-amber-700 hover:text-amber-900' :
                location.pathname === `/categorie/${cat.id}`
                  ? 'text-red-800'
                  : 'text-stone-700 hover:text-red-800'
              }`}
            >
              {cat.isPdf && '📄 '}{cat.isSpecial && !cat.isPdf && '📰 '}{cat.name}
            </Link>
          ))}
        </div>
        
        {/* Mobile menu button */}
        <div className="md:hidden flex items-center justify-center py-3">
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="text-stone-700 p-2"
            data-testid="mobile-menu-button"
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
        
        {/* Mobile navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-stone-200 py-4">
            <div className="flex flex-col space-y-3">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={cat.isSpecial ? `/${cat.id}` : `/categorie/${cat.id}`}
                  data-testid={`mobile-nav-${cat.id}`}
                  onClick={() => setMobileMenuOpen(false)}
                  className={`font-inter text-sm font-medium tracking-wide uppercase text-center py-2 transition-colors duration-200 ${
                    cat.isPdf ? 'text-red-600 hover:text-red-800' :
                    cat.isSpecial ? 'text-amber-700 hover:text-amber-900' :
                    location.pathname === `/categorie/${cat.id}`
                      ? 'text-red-800'
                      : 'text-stone-700 hover:text-red-800'
                  }`}
                >
                  {cat.isPdf && '📄 '}{cat.isSpecial && !cat.isPdf && '📰 '}{cat.name}
                </Link>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};
